import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
//import './index.css'
import App from "./App.jsx";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AppProvider } from "./components/util/AppProvider.jsx";
import { AuthProvider } from "./components/util/AuthContext.jsx";
import "react-datepicker/dist/react-datepicker.css"; 


createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
